/*
  Kingspan - Expivi preset preload config.

  Preset resolution order (implemented in expivi-modal.js):
    1) presetBySku[<SKU>]      EXCEPTIONS only -> many Shopify SKUs share ONE Expivi preset
    2) <SKU> itself            DEFAULT 1:1 -> the Expivi preset identifier == the product SKU
    3) products[<id>].preset   legacy per-product fallback

  MOST products are 1:1 and need NO entry here (their SKU is the preset identifier in Expivi).
  Only list MANY-TO-ONE exceptions below: each SKU -> the shared preset identifier.
*/
window.KingspanExpiviConfig = {
  // many-to-one overrides (SKU -> shared Expivi preset identifier)
  presetBySku: {
    // "SL-0700-1700-1855": "SL-0700-1700-1860",  // e.g. these SKUs all load the 1860 preset
    // "SL-0700-1700-1850": "SL-0700-1700-1860",
  },
  // legacy per-product fallback (used only when a product has no SKU and no override)
  products: {
    7331998728272: { preset: "slimline-tank" }
  }
};
